"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@popperjs/core");

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Dropdown = _interopRequireDefault(require("./Dropdown.provider"));

var _DropdownMenu = _interopRequireDefault(require("./DropdownMenu"));

var _DropdownButton = _interopRequireDefault(require("./DropdownButton"));

var _elements = require("../../styles/elements");

var _Dropdown2 = require("./Dropdown.styles");

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var line = (0, _jsxRuntime.jsx)("div", {
  css: _elements.divider.styles.base,
  role: "separator"
});

var Dropdown = function Dropdown(_ref) {
  var overlay = _ref.overlay,
      className = _ref.className,
      onSelect = _ref.onSelect,
      children = _ref.children,
      defaultVisible = _ref.defaultVisible,
      visible = _ref.visible,
      onVisibleChange = _ref.onVisibleChange,
      disabled = _ref.disabled,
      header = _ref.header,
      footer = _ref.footer,
      footerWithBtns = _ref.footerWithBtns,
      negativeHover = _ref.negativeHover,
      hasMinWidth = _ref.hasMinWidth,
      autoHeight = _ref.autoHeight,
      position = _ref.position,
      emptyHint = _ref.emptyHint,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      strategy = _ref.strategy;
  var popperRef = (0, _react.useRef)(null);
  var popperInstanceRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(defaultVisible),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var mergedVisible = visible !== undefined ? visible : open; // Verifies that children has only one child (a React element) and returns it.

  var childElement = _react["default"].Children.only(children);

  var triggerRef = (0, _react.useRef)(null);
  var modifiers = (0, _react.useMemo)(function () {
    return [{
      name: 'offset',
      options: {
        offset: [0, 5]
      }
    }];
  }, []);
  var show = (0, _react.useCallback)(function () {
    /* Enable the event listeners for updating position
     ** setOptions for modifiers will overwrite others modifiers
     * so need to merge with the default modifiers
     */
    popperInstanceRef.current.setOptions({
      modifiers: [].concat((0, _toConsumableArray2["default"])(modifiers), [{
        name: 'eventListeners',
        enabled: true
      }])
    }); // Update its position

    popperInstanceRef.current.update();
  }, [modifiers]);
  var hide = (0, _react.useCallback)(function () {
    // Disable the event listeners for updating position when the popup is hidden
    popperInstanceRef.current.setOptions({
      modifiers: [].concat((0, _toConsumableArray2["default"])(modifiers), [{
        name: 'eventListeners',
        enabled: false
      }])
    });
  }, [modifiers]); // Handle click trigger

  var handleClickTrigger = (0, _react.useCallback)(function () {
    if (disabled) return;
    setOpen(!open);
    onVisibleChange(!mergedVisible);

    if (!open) {
      show();
    } else {
      hide();
    }
  }, [disabled, open, onVisibleChange, mergedVisible, show, hide]); // If click outside the dropdown button or display area
  // Close the dropdown

  var handleClickOutside = (0, _react.useCallback)(function (event) {
    var path = event.path || event.composedPath && event.composedPath();

    if (!path.includes(triggerRef.current) && !path.includes(popperRef.current)) {
      setOpen(false);
      onVisibleChange(false);
    }
  }, [onVisibleChange]);
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  (0, _react.useEffect)(function () {
    // Only create popper instance once
    if (popperInstanceRef.current) {
      return undefined;
    }

    var triggerElement = triggerRef.current;
    var popperElement = popperRef.current; // Save the popper instance

    popperInstanceRef.current = (0, _core.createPopper)(triggerElement, popperElement, {
      placement: position,
      modifiers: modifiers,
      strategy: strategy
    });
    return function () {
      popperInstanceRef.current.destroy();
      popperInstanceRef.current = null;
    };
  }, [modifiers, position, strategy, triggerRef]);
  return (0, _jsxRuntime.jsx)(_Dropdown["default"], {
    negativeHover: negativeHover,
    onSelect: onSelect,
    setOpen: setOpen,
    emptyHint: emptyHint,
    children: (0, _jsxRuntime.jsxs)("div", {
      css: _Dropdown2.styles.base,
      children: [/*#__PURE__*/(0, _react.cloneElement)(childElement, {
        disabled: disabled,
        ref: triggerRef,
        onClick: handleClickTrigger
      }), (0, _jsxRuntime.jsxs)("div", {
        ref: popperRef,
        css: [_Dropdown2.styles.dropdownContainer, hasMinWidth && _Dropdown2.styles.minWidth, mergedVisible && _Dropdown2.styles.visible, autoHeight && _Dropdown2.styles.autoH, strategy === 'fixed' && _Dropdown2.styles.autoWidth, process.env.NODE_ENV === "production" ? "" : ";label:Dropdown;"],
        className: (0, _clsx["default"])('grui box-shadow-md', className),
        children: [header && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)("div", {
            css: _Dropdown2.styles.header,
            children: header
          }), line]
        }), overlay, footer && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [line, (0, _jsxRuntime.jsx)("div", {
            css: [_Dropdown2.styles.footer, footerWithBtns && _Dropdown2.styles.footerWithBtns, process.env.NODE_ENV === "production" ? "" : ";label:Dropdown;"],
            children: footer
          })]
        })]
      }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
        help: help,
        validateStatus: validateStatus
      })]
    })
  });
};

Dropdown.propTypes = {
  /**
   * Dropdown overlay
   */
  overlay: _propTypes.element,
  className: _propTypes.string,

  /**
   * select option handler
   */
  onSelect: _propTypes.func,
  children: _propTypes.node,
  defaultVisible: _propTypes.bool,

  /**
   * Control the visibility of Dropdown </br>
   * need to pass onVisibleChange together to be called when the open state is changed
   * If it's not provided, will use the open state to control the visibility
   */
  visible: _propTypes.bool,
  onVisibleChange: _propTypes.func,
  disabled: _propTypes.bool,

  /**
   * Dropdown overlay header
   */
  header: _propTypes.node,

  /**
   * Dropdown overlay footer
   */
  footer: _propTypes.node,
  footerWithBtns: _propTypes.bool,

  /**
   * Negative hover effect for menu item
   */
  negativeHover: _propTypes.bool,

  /**
   * Whether to set min-width (240) for dropdown menu </br>
   * if false, the width will be the same as the dropdown button </br>
   * or pass className to custom the style
   */
  hasMinWidth: _propTypes.bool,

  /**
   * Whether to remove overflow-hidden for dropdown-menu
   */
  autoHeight: _propTypes.bool,

  /**
   * Position of dropdown menu
   */
  position: (0, _propTypes.oneOf)(['bottom-start', 'bottom-end', 'top-start', 'top-end']),
  emptyHint: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,

  /**
   * Drodown menu's position style value
   * only change it when the dropdown is inside a scrollable or hidden container
   * because fixed menu won't get the width of its trigger element like a normal dropdown
   */
  strategy: (0, _propTypes.oneOf)(['absolute', 'fixed'])
};
Dropdown.defaultProps = {
  className: undefined,
  onSelect: function onSelect() {},
  defaultVisible: false,
  visible: undefined,
  onVisibleChange: function onVisibleChange() {},
  disabled: false,
  header: undefined,
  footer: undefined,
  footerWithBtns: false,
  negativeHover: false,
  hasMinWidth: false,
  autoHeight: false,
  position: 'bottom-start',
  emptyHint: undefined,
  overlay: (0, _jsxRuntime.jsx)(_DropdownMenu["default"], {}),
  children: undefined,
  help: undefined,
  validateStatus: undefined,
  strategy: 'absolute'
};
Dropdown.Menu = _DropdownMenu["default"];
Dropdown.Button = _DropdownButton["default"];
var _default = Dropdown;
exports["default"] = _default;
//# sourceMappingURL=Dropdown.js.map